import { TipoGenericoRimovibile } from './tipo-generico-rimovibile';

export const idControparteInTipoBeneficiario = '1';
export const idLegaleInTipoBeneficiario = '2';
export const idAltrePartiInTipoBeneficiario = '3';

export const tipiBeneficiarioPagamentoOptions: TipoGenericoRimovibile[] = [
  {id: idControparteInTipoBeneficiario, label: 'Parte', descrizione: 'Parte', rimosso: false},
  {id: idLegaleInTipoBeneficiario, label: 'Legale', descrizione: 'Legale', rimosso: false},
  {id: idAltrePartiInTipoBeneficiario, label: 'Altra parte', descrizione: 'Altra parte', rimosso: false},
];
